<template>
  <ControlElements :add-revealed-cards="addRevealedCards" :check-and-mark-sets="checkAndMarkSets" :num-of-detected-sets="numOfDetectedSets" :gameStatus="this.gameStatus" :controlGameStatus="controlGameStatus" :toggle-found-sets="toggleFoundSets" />

  <StatusBar :total="cardsTotal" :piled="cardsPiled" :open="cardsOpen" :found="cardsFound" />

  <div class="page" :class="this.$isMobile() ? 'mobile' : ''">
    <div class="cards cards-revealed cards-pickable" :class="this.computeRevealedCardsClass()">
      <!-- show only 9: array.slice(0,9) -->
      <!-- max iteration step 81 -->

      <SingleCard v-for="(card,index) in revealedDeck" v-bind:key="index"
                  :card="card"
                  :order-id="index"
                  :is-picked="isPicked(index)"
                  :is-marked-invalid="isInvalid(index)"
                  :is-marked-valid="isValid(index)"
                  :is-gap-filler="isGapFiller(index)"
                  @click="pickCard(index)"/>

    </div>
    <div v-show="this.isShowFoundSets" class="cards cards-found-sets">
      <SingleCard v-for="(card,index) in foundSets" v-bind:key="index"
                  :card="card"
                  :order-id="index"
                  :class="'set-part-'+(index%3+1)"
                  />

    </div>
  </div>
</template>

<script>
import config from "@/assets/config.json";
import baseDeck from '@/assets/decks/fullDeckSorted.json'
import SingleCard from '@/components/SingleCard.vue'
import ControlElements from "@/components/ControlElements.vue";
import StatusBar from "@/components/StatusBar.vue";

export default {
  name: 'FullGame',
  components: {
    ControlElements,
    StatusBar,
    SingleCard
  },
  methods: {
    isPicked(i) {
      return this.pickedCardIndexes.includes(i);
    },
    isInvalid(i) {
      return this.invalidCardIndexes.includes(i);
    },
    isValid(i) {
      return this.validCardIndexes.includes(i);
    },
    isGapFiller(i) {
      return this.gapFillerIndexes.includes(i);
    },
    computeRevealedCardsClass() {
      if (this.gameStatus === 0 || this.gameStatus === 10) {
        return '';
      }
      return 'cards-obfuscated';
    },
    pickCard(i) {
      if (this.isPickingSuspended) {
        return;
      }
      if (this.gapFillerIndexes.includes(i)) {
        return;
      }
      if (this.pickedCardIndexes.includes(i)) {
        this.pickedCardIndexes = this.pickedCardIndexes.filter((val) => val !== i);
        return;
      } else {
        this.removeCardStatusMarkings();
        if (this.pickedCardIndexes.length < 3) {
          this.pickedCardIndexes.push(i);
        }
      }
      if (this.pickedCardIndexes.length === 3) {
        if ( this.isValidSet(this.revealedDeck[this.pickedCardIndexes[0]], this.revealedDeck[this.pickedCardIndexes[1]], this.revealedDeck[this.pickedCardIndexes[2]]) ) {

          // FOUND Set, now move found cards to foundSetsDeck
          this.markPickedCardsValid();
          this.transferPickedCardsToFoundSets();
          this.numOfDetectedSets = null;

        } else {
          // invalid set, now remove marks
          this.markPickedCardsInvalid();
        }

      }
    },
    isValidSet(card1, card2, card3) {
      return this.isAllEqualOrAllDifferent(card1, card2, card3, 0) &&
          this.isAllEqualOrAllDifferent(card1, card2, card3, 1) &&
          this.isAllEqualOrAllDifferent(card1, card2, card3, 2) &&
          this.isAllEqualOrAllDifferent(card1, card2, card3, 3);

    },
    isAllEqualOrAllDifferent(card1, card2, card3, specIndex) {
      // console.log('specification ' + specIndex + ': ' + card1[specIndex] + card2[specIndex] + card3[specIndex]);
      if (card1[specIndex] === card2[specIndex] && card2[specIndex] === card3[specIndex]) {
        // console.log('spec '+ specIndex + ': all same');
        return true;
      } else if ( card1[specIndex] !== card2[specIndex] && card2[specIndex] !== card3[specIndex] && card1[specIndex] !== card3[specIndex]) {
        // console.log('spec '+ specIndex + ': all different');
        return true;
      }
      return false;
    },
    shuffle() {
      if (config.shuffleLevel === -1) {
        // no shuffling - use base Deck as it is
        return;
      }
      let randomIndexesArray = config.randomOrderArray;
      //randomIndexesArray =   [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80];
      if (config.shuffleLevel === 1) {
        randomIndexesArray.sort(() => Math.random() - 0.5);
        randomIndexesArray.sort(() => Math.random() - 0.5);
        randomIndexesArray.sort(() => Math.random() - 0.5);
        randomIndexesArray.sort(() => Math.random() - 0.5);
      }

      // then fill shuffledDeck with randomized indexes:
      let tmpDeck = [];
      for (let i = 0; i < randomIndexesArray.length; i++) {
        tmpDeck.push(this.baseDeck[randomIndexesArray[i]]);
      }

      this.shuffledDeck = tmpDeck;
    },
    splitShuffledDeck() {
      this.revealedDeck = [];

      for (let i = 0; i < this.shuffledDeck.length; i++) {
        if (i < this.numOfRevealedCards) {
          this.revealedDeck.push(this.shuffledDeck[i]);
        } else {
          this.stackedDeck.push(this.shuffledDeck[i]);
        }
      }
    },
    checkAndMarkSets(toBeMarked) {
      this.removeCardStatusMarkings();
      let numOfDetectedSets = 0;
      for (let i = 0; i < this.revealedDeck.length-2; i++) {
        if (this.gapFillerIndexes.includes(i)) continue;
        for (let j = i+1; j < this.revealedDeck.length-1; j++) {
          if (this.gapFillerIndexes.includes(j)) continue;
          for (let k = j+1; k < this.revealedDeck.length; k++) {
            if (this.gapFillerIndexes.includes(k)) continue;
            if ( this.isValidSet(this.revealedDeck[i], this.revealedDeck[j], this.revealedDeck[k]) ) {
              if (toBeMarked==='found' || toBeMarked==='first') {
                this.validCardIndexes.push(i);
                this.validCardIndexes.push(j);
                this.validCardIndexes.push(k);
                if (toBeMarked==='first') {
                  toBeMarked = 'none';
                }
              }
              numOfDetectedSets++;
            }        
          }
        }
      }
      if (toBeMarked==='all') {
        let tmpArray = [];
        for (let i = 0; i < this.revealedDeck.length; i++) {
          tmpArray.push(i);
        }
        if (numOfDetectedSets===0) {
          this.invalidCardIndexes = tmpArray;
        } else {
          this.validCardIndexes = tmpArray;
        }
      }
      this.numOfDetectedSets = numOfDetectedSets;
      return numOfDetectedSets;
    },
    revealNewCards() {
      this.removeCardStatusMarkings();
      if (this.revealedDeck.length > this.numOfRevealedCards) {
        // rearrange first!
        this.rearrangeAndRemoveGaps();
        return;
      }

      for (let i = 0; i < 3; i++) {
        setTimeout(() => {
          this.removeCardStatusMarkings();
          if (this.stackedDeck.length > 0) {
            this.revealedDeck.splice(this.gapFillerIndexes[0], 1 , this.stackedDeck[0]);
            // TODO: use array.shift()
            this.gapFillerIndexes.splice(0,1);
            this.stackedDeck.splice(0,1);
          } else {
            // now start looking for end of game
            if (this.gameStatus === 0 && this.checkAndMarkSets('none') === 0) {
              this.controlGameStatus(10);
            }
          }
        }, i*this.timerMoveCardsWait);
      }

    },
    controlGameStatus(newStatus) {
      if (newStatus === -2) {
        window.location.reload();
      } else {
        this.gameStatus = newStatus;
      }
    },
    addRevealedCards() {
      this.removeCardStatusMarkings();
      for (let i = 0; i < 3; i++) {
        setTimeout(() => {
          if (this.stackedDeck.length > 0) {
            this.revealedDeck.push(this.stackedDeck[0]);
            // TODO: use array.shift()
            this.stackedDeck.splice(0,1);
          } else {
            console.log("no cards left");
          }
        }, i*this.timerMoveCardsWait);
      }

    },
    toggleFoundSets() {
      console.log('in togglefoundsets');
      this.isShowFoundSets = !this.isShowFoundSets;
    },
    removeCardStatusMarkings() {
      this.invalidCardIndexes = [];
      this.validCardIndexes = [];
    },
    rearrangeAndRemoveGaps() {
      let gaps = this.gapFillerIndexes;
      for (let i = 0; i < gaps.length; i++) {
        setTimeout(() => {
          this.swapCards(gaps[i],this.maxCardIndex());
        }, i*this.timerMoveCardsWait);
      }
      setTimeout(() => {
        for (let i = this.revealedDeck.length-1; i >= this.numOfRevealedCards; i--) {
          if (this.gapFillerIndexes.includes(i)) {
            this.revealedDeck.splice(i, 1);
            this.gapFillerIndexes = this.gapFillerIndexes.filter((val) => val !== i);
          }
        }
      }, (gaps.length+2)*this.timerMoveCardsWait);
    },
    swapCards(index1, index2) {
      let tmpCard1 = this.revealedDeck[index1];  
      let tmpCard2 = this.revealedDeck[index2];  
      this.revealedDeck.splice(index1, 1 , tmpCard2);
      this.revealedDeck.splice(index2, 1 , tmpCard1);
      if (this.gapFillerIndexes.includes(index1) && this.gapFillerIndexes.includes(index2)) {
        //  both are empty - do nothing with gap indexes
      } else if (this.gapFillerIndexes.includes(index2)) {
        this.gapFillerIndexes = this.gapFillerIndexes.filter((val) => val !== index2);
        this.gapFillerIndexes.push(index1);
      } else if (this.gapFillerIndexes.includes(index1)) {
        this.gapFillerIndexes= this.gapFillerIndexes.filter((val) => val !== index1);
        this.gapFillerIndexes.push(index2);
      }
    },
    maxCardIndex() {
      let maxIndex = 0;
      for (let i = this.revealedDeck.length-1; i >=0  ; i--) {
        if (!this.gapFillerIndexes.includes(i)) {
          maxIndex = i;
          break;
        }
      }
      return maxIndex;
    },
    markPickedCardsInvalid() {
      this.invalidCardIndexes = [];
      //this.removeCardStatusMarkings();
      for (let i = 0; i < this.pickedCardIndexes.sort().reverse().length; i++) {
        this.invalidCardIndexes.push(this.pickedCardIndexes[i]);
      }
      this.pickedCardIndexes = [];
      setTimeout(() => {
        this.invalidCardIndexes = [];
        //this.removeCardStatusMarkings();
      }, this.timerShowCardsStatus);

    },
    markPickedCardsValid() {
      this.validCardIndexes = [];
      for (let i = 0; i < this.pickedCardIndexes.length; i++) {
        this.validCardIndexes.push(this.pickedCardIndexes[i]);
      }
    },
    transferPickedCardsToFoundSets() {
      this.isPickingSuspended = true;
      let indexesToRemove = this.pickedCardIndexes;
      this.pickedCardIndexes = [];

      // first move the cards to found sets area in picked order, then remove after sort - never split the following two loops!
      for (let i = 0; i < indexesToRemove.length; i++) {
        setTimeout(() => {
          this.foundSets.push(this.revealedDeck[indexesToRemove[i]]);
          this.gapFillerIndexes.push(indexesToRemove[i]);
          if ( i === indexesToRemove.length - 1 ) {
            this.validCardIndexes = [];
          }
        }, i*this.timerMoveCardsWait);
      }
      // indexesToRemove.sort((a,b) => a-b).reverse();

      /*
      setTimeout(() => {
        this.validCardIndexes = [];
      }, this.timerShowCardsStatus);
       */

      setTimeout(() => {
        this.isPickingSuspended = false;
        this.gapFillerIndexes.sort();
        this.revealNewCards();
      }, 5*this.timerMoveCardsWait);

    }

  },
  mounted() {
    this.shuffledDeck = baseDeck;
    this.shuffle();
    this.splitShuffledDeck();
    this.gameStatus = -1; // don't start game right after mounted
  },
  data() {
    return {
      timerMoveCardsWait: config.timerMoveCardsWait,
      timerShowCardsStatus: config.timerShowCardsStatus,
      numOfRevealedCards: config.numOfRevealedCards,
      gameStatus: -1, // means before start - 0: ongoing - 1: ended
      baseDeck: baseDeck,
      shuffledDeck: [],
      revealedDeck: [],
      stackedDeck: [],
      foundSetsDeck: [],
      numOfDetectedSets: null,
      foundSets: [],
      gapFillerIndexes: [],
      pickedDeck: [],
      pickedCardIndexes: [],
      isPickingSuspended: false,
      isShowFoundSets: !this.$isMobile(),
      invalidCardIndexes: [],
      validCardIndexes: [],
      config: config,
      debugMode: config.debugMode
    }
  },
  computed: {
    cardsTotal: function () {
      return this.shuffledDeck.length;
    },
    cardsPiled: function () {
      return this.stackedDeck.length;
    },
    cardsOpen: function () {
      return this.revealedDeck.length - this.gapFillerIndexes.length;
    },
    cardsFound: function () {
      return this.foundSets.length;
    }
  },
  props: {
    /* choose design in SingleCard for now */
  }

}
</script>

<style>
.page {
  display: flex;

  .cards-revealed {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    gap: 8px;
  }

  &.mobile {
    .cards-revealed {
      max-width: none;

      .card {

      }
    }
    .cards-found-sets {
      justify-content: end;
      position: absolute;
      right: 0px;
    }
  }

  .cards-found-sets {
    display: flex;
    max-width: 810px;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 420px;

    .card {
      transform: rotate(10deg);
      width: 130px;
      height: 80px;
    }

    .set-part-2 {
      margin-left: -40px;
      margin-top: 10px;
    }
    .set-part-3 {
      margin-left: -40px;
      margin-top: 20px;
    }
  }
}

.page-obfuscated, .cards-obfuscated, .card-obfuscated {
  .card {
    .svg-symbol, .symbol {
      display: none;
    }

  }
}
</style>
